import { useState, useCallback, useEffect } from 'react';
import { Bookmark, TreeNode } from '../types';

export function useBookmarks() {
  const [bookmarks, setBookmarks] = useState<Bookmark[]>(() => {
    const saved = localStorage.getItem('ectd-bookmarks');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        return parsed.map((b: any) => ({
          ...b,
          addedAt: new Date(b.addedAt)
        }));
      } catch {
        return [];
      }
    }
    return [];
  });

  useEffect(() => {
    localStorage.setItem('ectd-bookmarks', JSON.stringify(bookmarks));
  }, [bookmarks]);

  const addBookmark = useCallback((node: TreeNode, path: string[], note?: string) => {
    const bookmark: Bookmark = {
      id: `${node.type}-${node.name}-${Date.now()}`,
      node,
      path,
      addedAt: new Date(),
      note
    };
    
    setBookmarks(prev => [...prev, bookmark]);
  }, []);

  const removeBookmark = useCallback((node: TreeNode) => {
    setBookmarks(prev => prev.filter(b => 
      !(b.node.type === node.type && b.node.name === node.name)
    ));
  }, []);

  const isBookmarked = useCallback((node: TreeNode) => {
    return bookmarks.some(b => 
      b.node.type === node.type && b.node.name === node.name
    );
  }, [bookmarks]);

  const clearBookmarks = useCallback(() => {
    setBookmarks([]);
  }, []);

  return {
    bookmarks,
    addBookmark,
    removeBookmark,
    isBookmarked,
    clearBookmarks,
  };
}

